import type { ProductInfoFromReviewProps } from './ProductInfoFromReview';
import { ProductInfoFromReview } from './ProductInfoFromReview';
import type { ProductInfoFromSlugProps } from './ProductInfoFromSlug';
import { ProductInfoFromSlug } from './ProductInfoFromSlug';

type ProductInfoProps = ProductInfoFromSlugProps | ProductInfoFromReviewProps;

/* eslint-disable react/destructuring-assignment */
export function ProductInfo(props: ProductInfoProps) {
  if ('review' in props && props.review) {
    return <ProductInfoFromReview {...props} />;
  }

  if ('slug' in props && props.slug) {
    return <ProductInfoFromSlug {...props} />;
  }

  return null;
}
